import styled from "styled-components"

export const YourWishWrapper = styled.div`
background-color: #F1F1F1;
width: 100vw;
height: 300px;
padding-top: 10px;
padding-bottom: 10px;
display: flex;
flex-wrap: wrap;
justify-content: center;
overflow-x: hidden;

@media(max-width: 768px){
    height: auto;
}
`;
export const FormLeft = styled.div`
background-color: #ffffff;
width: 25vw;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding-top: 10px;
padding-bottom: 10px;
border-radius: 4px;
height: 250px;
margin-right: 20px;
height: 100%;

@media(max-width: 768px){
    width: 90%;
    align-self: center;
    margin-bottom: 20px;
    margin-right: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 200px;
}
`;
export const FormHeader = styled.div`
color: #0E8FD8;
text-transform: capitalize;
font-size: 16px;
padding-bottom: 10px;
font-weight: 500;

@media(max-width: 768px){
    font-size: 14px;
}
`;
export const Form = styled.form`
display: flex;
// background-color: tomato;
flex-direction: column;
width: 80%;
// gap: 10px;

@media(max-width: 768px){
}
`;

export const WishesRight = styled.div`
background-color: #ffffff;
width: 40vw;
height: 100%;
border-radius: 4px;
padding-top: 10px;
padding-bottom: 10px;
display: flex;
flex-direction: column;
align-items: center;
overflow-y: auto;

@media(max-width: 768px){
    width: 90%;
    height: auto;
    overflow-y: none;
}
`;

export const MiddleDivider = styled.div`
display: none;

@media(max-768px){
    background-color: blue;
    display: block;
    margin-left: 10px;
    margin-right: 10px;
}
`;
// export const YourWishWrapper = styled.div``;
// export const YourWishWrapper = styled.div``;